/** Loading statuses used to determine state of method calls to update UI */
export enum LoadingStatus {
    loading = 'loading',
    idle = 'idle',
    error = 'error'
}
